import { Outlet } from "react-router-dom";
import { AdminSidebar } from "../../components/admin/AdminSidebar";

export function AdminLayout() {
  return (
    <div className="admin-console flex h-screen bg-background">
      <AdminSidebar />
      <main className="flex-1 overflow-auto bg-background transition-all duration-300">
        <div className="p-4 lg:p-8 pt-16 lg:pt-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
